<template>
  <SiteHeader :hide-logo="$siteConfig.brand ==='BookDirect'"/>
  <main>
    <slot />
  </main>
  <SiteFooter/>
  <CookiesNotes />
</template>
<script setup lang="ts">
import {useBookingStore} from '~/store/booking'
import CookiesNotes from "~/components/CookiesNotes.vue";
const { $siteConfig } = useNuxtApp()
const { locale } = useI18n()
const config = useRuntimeConfig()
const configData = config.public
useHead({
  bodyAttrs: {
    class: 'custom-scrollbar'
  },
  htmlAttrs: {
    lang: locale.value,
  },
});


const brand = $siteConfig.value.brand
const logo = $siteConfig.value.logo
const siteHost = configData.baseURL


const agencyHost = configData.siteName ? `https://${configData.siteName}` : ''
const agencyLogo = agencyHost && logo ? `${agencyHost}${logo.startsWith('/') ? '' : '/'}${logo}` : ''

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'TravelAgency',
  'name': brand || 'Tripening',
  'description': 'Everything You Need In One Place!',
  'address': 'New York',
  // `siteName` is on runtimeConfig.public, not $siteConfig — reading it off the
  // latter made this render as "undefined/undefined" on every page.
  ...(agencyLogo && { 'image': agencyLogo }),
}

useJsonld(() => (jsonLd as any));

</script>

<style lang="scss" scoped>
main {
  width: 100%;
  margin: 0;
  display: block;
}
</style>
